import React from 'react';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';
import { COLOR_SCHEMES, SIZES } from '~/packages/common-frontend/theme';

// Constants
const COMPONENT_NAME = './common-frontend/IconButtonV2';
const VARIANTS = [
  'primary',
  'primary-muted',
  'secondary',
  'secondary-muted',
  'v2-ghost',
] as const;

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <PageTemplate title={COMPONENT_NAME}>
      <ComponentGridRenderer
        primaries={VARIANTS}
        primaryPropName="variant"
        secondaries={COLOR_SCHEMES}
        secondaryPropName="colorScheme"
        tertiaries={SIZES}
        tertiaryPropName="size"
      >
        {({ primary: variant, secondary: colorScheme, tertiary: size }) => {
          const Component = IconButtonV2;

          const commonProps = {
            label: COMPONENT_NAME,
            placement: 'bottom' as const,
            variant,
            hasDotIndicator: true,
            colorScheme,
            size,
            icon: <Icon icon="message-lines" />,
          };

          return (
            <>
              <Component {...commonProps} aria-label="isLoading" isLoading />
              <Component {...commonProps} aria-label="isDisabled" isDisabled />
              <Component {...commonProps} aria-label="base" />
              <Component {...commonProps} aria-label="isActive" isActive />
            </>
          );
        }}
      </ComponentGridRenderer>
    </PageTemplate>
  </RouteErrorBoundary>
);
